import { parseReturnUrl, splitRelativeUrl } from '@klear/ui/wizard/return-url'

export function returnUrlWithOrderId(returnUrl: string, orderId: number, payableOrReceivableSegment: string): string {
  const safe = parseReturnUrl(returnUrl)
  if (safe == null) return returnUrl

  const { pathOnly, search, hash } = splitRelativeUrl(safe)
  const segments = pathOnly.split('/').filter(Boolean)
  const last = segments[segments.length - 1]

  if (last === payableOrReceivableSegment) {
    return `/${segments.join('/')}/order/${orderId}${search}${hash}`
  }

  if (
    segments.length >= 3 &&
    segments[segments.length - 2] === 'order' &&
    segments[segments.length - 3] === payableOrReceivableSegment
  ) {
    const base = segments.slice(0, -1).join('/')
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    params.delete('purchaseOrderId')
    const qs = params.toString()
    return `/${base}/${orderId}${qs ? `?${qs}` : ''}${hash}`
  }

  return safe
}
